import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { closeApartment } from './';
import ViewLevelViews from './ViewLevelViews';
import ViewLevelViewEnlarged from './ViewLevelViewEnlarged';

function ViewResidencesApartment({ residences, closeApartment }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [selectedView, setSelectedView] = useState(null);
  const nodeRef = useRef(null);

  // Keep last valid apartment so the component stays mounted during fade-out
  // (CLOSE_APARTMENT sets apartment: null immediately, which would kill the exit transition)
  const lastApartmentRef = useRef(residences.apartment);
  if (residences.apartment) lastApartmentRef.current = residences.apartment;
  const apartment = residences.isApartmentActive
    ? residences.apartment
    : lastApartmentRef.current;

  const lastSelectedLevelRef = useRef(residences.selectedLevel);
  if (residences.isApartmentActive) lastSelectedLevelRef.current = residences.selectedLevel;
  const selectedLevel = residences.isApartmentActive
    ? residences.selectedLevel
    : lastSelectedLevelRef.current;

  useEffect(() => {
    setImgLoaded(false);
    setSelectedView(null);

    if (residences.apartment) {
      const img = new Image();
      img.src = `./img/floor-plans/floorplan-type-${residences.apartment}.jpg`;
      img.onload = () => setImgLoaded(true);
    }
  }, [residences.apartment]);

  // Never return null — CSSTransition needs the node to be present to run exit
  if (!apartment) return null;

  return (
    <CSSTransition
      nodeRef={nodeRef}
      in={residences.isApartmentActive}
      timeout={500}
      classNames='apartment-fade'
      unmountOnExit
    >
      <div
        ref={nodeRef}
        className='residences--apartment'
        style={{ opacity: imgLoaded ? 1 : 0, transition: 'opacity 500ms ease' }}
      >
        <div className='residences--apartment-container'>
          <img
            className='shared--img-fill'
            src={`./img/floor-plans/floorplan-type-${apartment}.jpg`}
            width='1920'
            height='1080'
            alt='residences apartment floorplan'
          />

          {/* Level Views panel — hidden on Level 1 */}
          {selectedLevel !== 'Level 1' && (
            <ViewLevelViews
              apartmentType={apartment}
              selectedLevel={selectedLevel}
              isEnlargedOpen={!!selectedView}
              onSelectView={(view) => setSelectedView(view)}
            />
          )}

          {/* Enlarged level view image */}
          <ViewLevelViewEnlarged
            view={selectedView}
            onClose={() => setSelectedView(null)}
          />

          <button
            className='residences--apartment__close-btn'
            onClick={closeApartment}
          />
        </div>
      </div>
    </CSSTransition>
  );
}

const mapStateToProps = (state) => ({
  residences: state.residences,
});

const mapDispatchToProps = (dispatch) => ({
  closeApartment: () => dispatch(closeApartment()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewResidencesApartment);
